export default function convertToFormDataObject(jsObject) {
  /** Converts a plain JS Object into a FormData object */
  let formData = new FormData();

  for (let key in jsObject) {
    formData.append(key, jsObject[key]);
  }
  return formData;
  /**
   let formString = [];
   for (let key in jsObject) {
        if (jsObject.hasOwnProperty(key)) {
            formString.push(encodeURIComponent(key) + "=" + encodeURIComponent(jsObject[key]).replace(/%20/g, "+"));
        }
    }
   return formString.join("&");
   */
}